import {  createSlice } from "@reduxjs/toolkit";

// localityList can be [],
// setExpiryDate 1 when expirydate is selected. otherwise 0. Expiryadate should not be selected
const initialState: any = {
  jobPostingStartTime: null,
  ai_skills_edit: false,
  applicationsViaMail: "1",
  applyUrl: "",
  autoRenew: "disabled",
  categoryList: [],
  channelId: null,
  companyName: "",
  companyProfile: "",
  contractJobBillingDuration: "",
  contractJobContractTenure: "",
  corpId: 0,
  currencyId: "",
  description: "",
  educationList: [],
  folder_name_edit: false,
  gen_ai_usage: false,
  hideCorpName: "0",
  includeOtherPRHolders: "0",
  include_relocating_candidates: 1,
  industryList: [],
  inventoryConsumed: 0,
  is_army_veteran:"0",
  is_disabled: "0",
  isFreeWalkin: "0",
  is_lgbtq:"0",
  isQuickJob: 0,
  is_ai_job_content: false,
  jobPostingType: "JP",
  jobType: "fulltime",
  job_priority: {
    useKeySkillsSynonm:"1",
    maxSalaryFilter: 0,
    minSalaryFilter: 0,
    profilesWithoutSalary: 0,
    locationFilter: 0,
    nationalityFilter: 0,
    educationFilter: 0,
    experienceFilter: 0,
    industryFilter: 0,
    salaryFilter: 0,
    industry_list_priority: [],
    location_list_priority: [],
    includeOtherIndustryOptedProfiles: 0,
    nationality_list_priority: [],
    includeOtherPRHoldersFilter: "0",
    skillFilter: 0,
    ignoredSkills: [],
    prioritySkills: [],
  },
  languageList: [],
  localityList: [],
  locationList: [],
  maxExperience: null,
  maxSalary: null,
  minExperience: null,
  minSalary: null,
  nationalityList: [],
  notify: "1",
  ownerDesignation: "",
  ownerEmail: "",
  ownerName: "",
  ownerPhone: "",
  ownerProfileURL: null,
  preferredLocationList:[],
  refCode:"",
  recruiterId: 0,
  recruiter_info_edit: false,
  renewal: false,
  refreshPeriodicity: 0,
  folderId: 0,
  mapToExistingFolderId: 0,
  folderInput:"",
  is_questionnaire_attached:false,
  roleList: [],
  salaryConfidential: 0,
  scheduleChanged: false,
  sellingPoint1: "",
  expireDate: "",
  setExpiryEnabled: 0,
  shareContactInfo: "0",
  showOnSocial: false,
  siteContext: "",
  skillList: [],
  startDate: "",
  endDate: "",
  status: "",
  subChannelId: null,
  title: "",
  walkinEndDate: "",
  walkinStartDate: "",
  walkinVenueScheduledSlotDetails: [
    {
      contactPersonName: "",
      contactPersonPhone: "",
      endTime: "",
      slots: {},
      startTime: "",
      venueID: 1,
      venueAddress: "",
      venueLocation: "",
      walkinDates: [],
    },
  ],
  womenOnTop: "0",
  workMode: "0",
  work_authorization_filter: "0",
};

const jobPostingFormSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    updateFormField: (state, action) => {
      const { field, value } = action.payload;

      // Split the field string into an array of nested properties
      const fieldArray = field.split(".");

      // Reference to the current state object
      let currentState = state;

      // Traverse the nested properties and update the value
      for (let i = 0; i < fieldArray.length - 1; i++) {
        // Check if the current property exists, if not, initialize it as an object
        if (!currentState[fieldArray[i]]) {
          currentState[fieldArray[i]] = {};
        }

        // Move to the next nested property
        currentState = currentState[fieldArray[i]];
      }

      // Update the last nested property with the new value
      currentState[fieldArray[fieldArray.length - 1]] = value;
    },
    submitForm: (state) => {
      // Logic to handle form submission (e.g., API call)
      // Reset form fields after successful submission if needed
      return initialState;
    },
    resetForm: () => initialState,
    updateFormData: (state, action) => {
      // Merge incoming form data with the current state
      return {
        ...state,
        ...action.payload, // Overwrite existing fields with new values
      };
    },
  },
});

export const { updateFormField, submitForm, resetForm, updateFormData } =
  jobPostingFormSlice.actions;
export default jobPostingFormSlice;
